import i18next from 'i18next';
import React from 'react';

import { InpulseLabel } from '@commons/DeepsightComponents';
import DisplayNumber from '@commons/DisplayNumber';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import { capitalize } from 'lodash';
import { ClickableName } from '../styledComponents';

const SUPPLIER_PRODUCT_DETAILS_PATH = '/admin/suppliers/supplier-products';

const VALUE_PLACEHOLDER = '-';

/**
 * Green when the supplier product is available on every delivered store, red when it is available
 * on none of them, orange otherwise
 */
const getAvailabilityColor = (count, deliveredStoresCount) => {
  if (!count) {
    return 'red';
  }

  if (count === deliveredStoresCount) {
    return 'green';
  }

  return 'orange';
};

const renderAvailabilityLabel = (count, { suppliedStoreCount }) => (
  <InpulseLabel
    color={getAvailabilityColor(count, suppliedStoreCount)}
    text={`${count}/${suppliedStoreCount}`}
  />
);

const getAvailabilityColumn = (propertyKey, name) => ({
  id: propertyKey,
  propertyKey,
  name,
  filterType: 'numeric',
  excludeFromSearch: true,
  render: renderAvailabilityLabel,
});

export const getListColumns = (clientStoreNamePlural) => [
  {
    id: 'name',
    propertyKey: 'name',
    name: i18next.t('GENERAL.NAME'),
    displayBigger: true,
    render: (name, { id }) => (
      <ClickableName
        onClick={(event) => {
          event.stopPropagation();
          window.open(`${SUPPLIER_PRODUCT_DETAILS_PATH}/${id}/details`, '_blank');
        }}
      >
        <Text color={ENUM_COLORS.BLACK} font={ENUM_FONTS.TEXT_SMALL_BOLD}>
          {name}
        </Text>
      </ClickableName>
    ),
  },
  {
    id: 'category',
    propertyKey: 'category',
    name: i18next.t('GENERAL.CATEGORY'),
    filterType: 'string',
    filterStringAllowNone: true,
    render: (category) => <Text>{category || VALUE_PLACEHOLDER}</Text>,
  },
  {
    id: 'subCategory',
    propertyKey: 'subCategory',
    name: i18next.t('GENERAL.SUB_CATEGORY'),
    filterType: 'string',
    filterStringAllowNone: true,
    excludeFromSearch: true,
    render: (subCategory) => <Text>{subCategory || VALUE_PLACEHOLDER}</Text>,
  },
  {
    id: 'priceWithTaxes',
    propertyKey: 'priceWithTaxes',
    name: i18next.t('GENERAL.PRICE_TTC'),
    type: 'currency',
    filterType: 'numeric',
    excludeFromSearch: true,
    render: (priceWithTaxes) => <DisplayNumber number={priceWithTaxes} displayCurrencyCode />,
  },
  getAvailabilityColumn('availableStoreCount', i18next.t('ADMIN.STORES.LIST_COLUMN_AVAILABILITY')),
  getAvailabilityColumn('inventoryStoreCount', i18next.t('ADMIN.STORES.LIST_COLUMN_STOCKS')),
  getAvailabilityColumn('lossStoreCount', i18next.t('ADMIN.STORES.LIST_COLUMN_LOSS')),
  getAvailabilityColumn('transferStoreCount', i18next.t('ADMIN.STORES.LIST_COLUMN_TRANSFER')),
  {
    id: 'deliveredStoreCount',
    propertyKey: 'deliveredStoreCount',
    name: i18next.t('ADMIN.CENTRAL_PRODUCTS.DELIVERED_STORE', {
      storeName: capitalize(clientStoreNamePlural),
    }),
    filterType: 'numeric',
    excludeFromSearch: true,
    render: (deliveredStoreCount) => (
      <InpulseLabel color={deliveredStoreCount ? 'green' : 'red'} text={`${deliveredStoreCount}`} />
    ),
  },
];

export default { getListColumns };
